export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 500,
            staffing: 0.5,
            staffingCode: "da",
            equipment: ["Workstation"],
            software: ["Shipping Software"],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 1000,
            staffing:1,
            staffingCode: "da",
            equipment: ["Workstation"],
            software: ["Shipping Software"],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 2000,
            staffing: 1.5,
            staffingCode: "da",
            equipment: ["Workstation"],
            software: ["Shipping Software"],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 1,250 shipments per month",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 2,500 shipments per month",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 5,000 shipments per month",
                    value: 3
                }
            ]
        }

    ]
}
